import React from 'react';

import { ContactFlowNodeProps } from '..';
import BaseNode from '../BaseNode';

export default function AnswerNode(props: ContactFlowNodeProps) {
  return <BaseNode {...props} title='Answer' />;
}
